export const accessLevels = [
  {
    value: "user",
    name: "User",
  },
  {
    value: "admin",
    name: "Admin",
  },
  {
    value: "superadmin",
    name: "Super Admin",
  },
  {
    value: "companykeycontact",
    name: "Company Key Contact",
  },
];
